<lib-page-layout>
  <lib-title-navbar pageHeader title="Powiadomienia" [customBackUrl]="customBackUrl()"></lib-title-navbar>

  <div class="or-d-flex or-justify-content-center or-mx-20-px or-my-12-px or-gap-16-px">
    <button
      type="button"
      class="tabs__pill or-d-flex or-align-items-center or-justify-content-center or-px-16-px or-py-8-px or-head-xs or-cursor-pointer or-h-36-px"
      [class.button-primary-style]="activeTab() === 'notifications'"
      [class.button-secondary-style]="activeTab() !== 'notifications'"
      (click)="setActiveTab(notificationTab.Notifications)">
      <span>Powiadomienia</span>
      @if (notificationsUnreadCount() > 0) {
        <span class="tabs__badge or-bg-red or-color-white or-head-xs">{{ notificationsUnreadCount() }}</span>
      }
    </button>
    <button
      type="button"
      class="tabs__pill or-d-flex or-align-items-center or-justify-content-center or-px-16-px or-py-8-px or-head-xs or-cursor-pointer or-h-36-px or-ml-8-px"
      [class.button-primary-style]="activeTab() === 'alerts'"
      [class.button-secondary-style]="activeTab() !== 'alerts'"
      (click)="setActiveTab(notificationTab.Alerts)">
      <span>Alerty</span>
      @if (alertsUnreadCount() > 0) {
        <span class="tabs__badge or-bg-red or-color-white or-head-xs">{{ alertsUnreadCount() }}</span>
      }
    </button>
  </div>

  <div class="or-mx-16-px or-mb-20-px">
    <button
      type="button"
      class="settings-link or-d-flex or-align-items-center or-justify-content-center or-gap-8-px or-w-100-pc or-h-48-px or-px-16-px or-bg-white or-head-sm or-cursor-pointer"
      [routerLink]="settingsUrl()">
      <or-icon name="settings" size="m" />

      <span class="or-ml-8-px">{{ settingsLabel() }}</span>
    </button>

    @if (!isNotificationPermissionsEnabled()) {
      <div
        (click)="openNotificationPermissions()"
        class="notification-banner or-d-flex or-align-items-center or-justify-content-center or-w-100-pc or-h-48-px or-px-16-px or-mt-12-px or-cursor-pointer border-radius-8 or-text-md or-text-align-center">
        Włącz powiadomienia w aplikacji
      </div>
    }

    @if (isAlertsDisabledInfoVisible()) {
      <div class="or-text-md or-text-align-center or-mt-12-px">
        Nie masz jeszcze alertów. Włącz alerty w ustawieniach, aby otrzymywać powiadomienia o nowych gierkach w okolicy.
      </div>
    }
  </div>

  <div>
    @if (isPageLoaded()) {
      <div class="or-text-md or-mb-8-px or-mx-20-px">Nowe</div>
    }
    @if (!newNotifications().length && isPageLoaded()) {
      <div class="or-d-flex or-head-sm or-justify-content-center or-my-32-px">{{ emptyNewListLabel() }}</div>
    }
    @for (newNotification of newNotifications(); track newNotification.id) {
      <ng-container
        *ngTemplateOutlet="notificationTemplate; context: { $implicit: newNotification, isPast: false }"></ng-container>
      <div class="custom-divider or-w-90-pc or-my-12-px"></div>
    }
    @if (pastNotifications().length) {
      <div class="or-text-md or-mb-8-px or-mx-20-px or-mt-28-px">Przeszłe</div>
    }
    @for (pastNotification of pastNotifications(); track pastNotification.id; let last = $last) {
      <ng-container
        *ngTemplateOutlet="notificationTemplate; context: { $implicit: pastNotification, isPast: true }"></ng-container>
      <div class="custom-divider or-w-90-pc or-my-12-px" [class.hide-last-dividier]="last"></div>
    }
  </div>

  <ng-template #notificationTemplate let-notification let-isPast="isPast">
    <div
      (click)="redirect(notification)"
      class="or-d-flex or-align-items-center or-mx-20-px"
      [class.opacity-past]="isPast">
      <div class="or-position-relative">
        @if (!specificNotificationImage.includes(notification.type)) {
          <lib-or-avatar
            [avatarUrl]="notification.avatar"
            [avatarSize]="'md'"
            [initials]="notification.displayName"></lib-or-avatar>
        } @else {
          <img [src]="notification.avatar" class="or-mr-8-px custom-image" />
        }
        @if (!isPast) {
          <img src="assets/icons/unread-icon.svg" class="unread-dot or-h-20-px or-w-20-px or-position-absolute" />
        }
      </div>
      <div>
        <div class="or-color-secondary-2 or-head-xs or-mb-2-px">{{ notification.createdAt }}</div>
        <div class="or-text-md or-mb-2-px">{{ notification.title }}</div>
        <div class="or-head-xs">{{ notification.description }}</div>
        @if (notification.formattedDate) {
          <div class="or-text-sm">{{ notification.formattedDate }}</div>
        }
      </div>
    </div>
  </ng-template>
</lib-page-layout>
